import {classNames, React, observer} from '@api'
import {Button, Icon, Menu, MenuItem, Popover} from '@blueprintjs/core'
import {Tooltip2} from '@api'
import {useStores} from '@modules/VipLocalStore'
import {ui, useCatalog} from '@stores'
import {PrimaryIconButton} from 'centric-ui-components'
import * as css from './GroupByToolbar.css'
import {GroupByToolbarChips, GroupByToolbarItems} from '..'

export const GroupByToolbar = observer<{ className?: string }>(function GroupByBuilder({className}) {
  const {groupBy, isGlobalStore, cloudPDF, catalog: {isShowingClientPDF}} = useStores()

  if (isGlobalStore || groupBy.groupByFields.length == 0) return null
  if (isShowingClientPDF && cloudPDF.enabled && cloudPDF.component?.selectedTemplate?.catalogFeatures?.groupBy === false) return null

  return (
    <div className={classNames(css.root, className)}
         data-type='GroupByToolbar'>
      {/*<span className={css.groupByLabel}>Group By</span>*/}
      <GroupByToolbarChips/>

      <div className={css.groupToolbarButtons}>
        <GroupByToolbarItems/>
      </div>
    </div>
  )
})

export const ExpandCollapseAllGroupsToolbarButtons = observer(function ExpandCollapseAllGroupsToolbarButtons() {
  const {groupBy, assortments} = useCatalog(),
    {strings, isGroupedView, collapseAll, expandAll} = groupBy

  return (isGroupedView || (assortments?.selectedAssortment && !assortments.settings.columnView)) ? (
    <div className={css.expandCollapseButtons}>
      <Tooltip2 key='collapse-all' content={strings.collapseAll} placement='bottom'>
        <PrimaryIconButton data-id='collapse-all' disabled={groupBy.isCollapsedAll} onClick={e => collapseAll()}>
          <Icon icon='double-chevron-up'/>
        </PrimaryIconButton>
      </Tooltip2>
      <Tooltip2 key='expand-all' content={strings.expandAll} placement='bottom'>
        <PrimaryIconButton data-id='expand-all' disabled={groupBy.isExpandedAll} onClick={e => expandAll()}>
          <Icon icon='double-chevron-down'/>
        </PrimaryIconButton>
      </Tooltip2>
    </div>) : null
})


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/Menus/Toolbar/GroupByToolbar.tsx